import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import AdminLayout from '../../components/admin/AdminLayout';
import api from '../../utils/api';

export default function AdminUserForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  const [form, setForm] = useState({ name: '', email: '', role: 'editor', is_active: true, password: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isEdit) {
      setLoading(false);
      return;
    }

    api.get('/admin/users')
      .then((res) => {
        const user = res.data.find((item) => String(item.id) === id);
        if (!user) return toast.error('Përdoruesi nuk u gjet.');
        setForm({
          name: user.name || '',
          email: user.email || '',
          role: user.role || 'editor',
          is_active: user.is_active === 1 || user.is_active === true,
          password: '',
        });
      })
      .catch(() => toast.error('Gabim gjatë ngarkimit.'))
      .finally(() => setLoading(false));
  }, [id, isEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (isEdit) {
        await api.put(`/admin/users/${id}`, {
          name: form.name,
          email: form.email,
          role: form.role,
          is_active: form.is_active,
        });
        toast.success('Përdoruesi u përditësua.');
      } else {
        if (!form.password) return toast.error('Fjalëkalimi është i detyrueshëm.');
        await api.post('/admin/users', form);
        toast.success('Përdoruesi u krijua.');
      }
      navigate('/admin/perdoruesit');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Gabim.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <AdminLayout><div className="spinner" /></AdminLayout>;

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1 className="page-title">{isEdit ? 'Ndrysho Përdoruesin' : 'Përdorues i Ri'}</h1>
        </div>
        <Link to="/admin/perdoruesit" className="btn btn-secondary">← Kthehu</Link>
      </div>

      <div className="card" style={{ padding: '1.5rem' }}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Emri *</label>
            <input className="form-input" value={form.name} required onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label">Email *</label>
            <input className="form-input" type="email" value={form.email} required onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))} />
          </div>
          {!isEdit && (
            <div className="form-group">
              <label className="form-label">Fjalëkalimi *</label>
              <input className="form-input" type="password" value={form.password} required onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))} />
            </div>
          )}
          <div className="form-group">
            <label className="form-label">Roli</label>
            <select className="form-input form-select" value={form.role} onChange={(e) => setForm((p) => ({ ...p, role: e.target.value }))}>
              <option value="editor">editor</option>
              <option value="admin">admin</option>
              <option value="superadmin">superadmin</option>
            </select>
          </div>
          <label className="form-label" style={{ display: 'block', marginBottom: '1rem' }}>
            <input type="checkbox" checked={form.is_active} onChange={(e) => setForm((p) => ({ ...p, is_active: e.target.checked }))} style={{ marginRight: '0.5rem' }} />
            Aktiv
          </label>

          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? 'Duke ruajtur...' : isEdit ? 'Ruaj përdoruesin' : 'Krijo përdorues'}
          </button>
        </form>
      </div>
    </AdminLayout>
  );
}
